// extracted by mini-css-extract-plugin
module.exports = {"clearpay-component":"Clearpay_clearpay-component__j6cEs","logo":"Clearpay_logo__8qPPi"};